import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'services-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './services-card.component.html',
  styleUrls: ['./services-card.component.css']
})
export class ServicesCardComponent implements OnInit {
  @Input() data: any = {
    data: {
      Owner: {
        name: "Vishal Aher",
        profilePicture: "https://images.pexels.com/photos/326055/pexels-photo-326055.jpeg?auto=compress&cs=tinysrgb&w=600",
        address: {
          location: "Pune H.O",
        }
      },
      serviceType: "Plumber",
      services: [
        {
          pipeFitting: "pipeFitting"
        }
      ],
      category: "ab",
      created: "xyz",
      workExperience: [
        {
          image: "string",
          description: "abv, dsrufeiolkr,dPODJDL"  
        }
      ]
    }
  }
  @Input() config: any = {
    config: {
      wrapperClass: 'wrapper',
      containerClass: 'container mt-5',
      cardClass: 'card shadow-sm',
      cardHeaderClass: 'card-header text-center',
      headingClass: 'h4',
      cardBodyClass: 'card-body',
      buttonContainerClass: 'd-flex justify-content-center mt-3',
      getServiceButtonClass: 'btn btn-success mx-2',
      viewProviderButtonClass: 'btn btn-secondary mx-2',
      textBoldClass: 'fw-bold',
      getServiceText: 'Apply Now',
      viewProviderText: 'View Recruiter'
    }
  }

  constructor(private view: ViewContainerRef) {}

  ngOnInit(): void {
    console.log('service Provider Data', this.data)
    try {
      if (typeof this.data === 'string') {
        this.data = JSON.parse(this.data);
      }
      if (typeof this.config === 'string') {
        this.config = JSON.parse(this.config);
      }
    } catch (error) {
      console.error('Error parsing input data:', error);
    }
  
  }
  
  

  getService(): void {
    alert('Your service has been opened successfully!');
  }

  redirectToServiceProvider(): void {
    if (!this.data?.userId) {
      console.error('User ID is missing');
      return;
    }

    const serviceProviderId = this.data?.WidgetDetails?.config?.serviceProviderProfileLinkToId || 'defaultId';
    
    const dataParams = {
      where: { id: this.data.userId }
    };
    
    const queryParams = {
      dataModel: 'citizen-users',
      dataParams: JSON.stringify(dataParams)
    };
    
    console.log('Redirect Params:', JSON.stringify(dataParams));
    
    const customEvent = new CustomEvent('redirect', {
      bubbles: true,
      cancelable: true,
      detail: {
        data: {
          isExternalRedirect: false,
          redirectUrl: `/w/${serviceProviderId}/ServiceProviderProfile`,
          queryParams: JSON.stringify(queryParams)
        }
      }
    });
    
    this.view.element.nativeElement.dispatchEvent(customEvent);
  }
}
